import apiService from './apiService';

export const meetingsService = {
  // ==================== Meetings CRUD ====================

  async getMeetings(params?: { status?: string; startDate?: string; endDate?: string; page?: number; limit?: number }): Promise<any> {
    return apiService.get('/meetings', { params });
  },

  async getMeeting(id: string): Promise<any> {
    return apiService.get(`/meetings/${id}`);
  },

  async createMeeting(data: {
    title: string;
    description?: string;
    startTime: string;
    endTime: string;
    participantIds: string[];
    type?: 'one_on_one' | 'team' | 'group';
    location?: string;
    isRecurring?: boolean;
  }): Promise<any> {
    return apiService.post('/meetings', data);
  },

  async updateMeeting(
    id: string,
    data: {
      title?: string;
      description?: string;
      startTime?: string;
      endTime?: string;
      location?: string;
      status?: string;
    }
  ): Promise<any> {
    return apiService.put(`/meetings/${id}`, data);
  },

  async deleteMeeting(id: string): Promise<void> {
    return apiService.delete(`/meetings/${id}`);
  },

  async getUpcomingMeetings(): Promise<any> {
    return apiService.get('/meetings/upcoming');
  },

  async getMeetingSuggestions(): Promise<any> {
    return apiService.get('/meetings/suggestions');
  },

  async generateMeetingLink(id: string): Promise<any> {
    return apiService.post(`/meetings/${id}/link`);
  },

  // ==================== Calendar Integrations ====================

  async getCalendarIntegrations(): Promise<any> {
    return apiService.get('/meetings/calendar/integrations');
  },

  async connectCalendar(data: { provider: 'google' | 'microsoft' | 'apple'; code?: string }): Promise<any> {
    return apiService.post('/meetings/calendar/connect', data);
  },

  async disconnectCalendar(integrationId: string): Promise<void> {
    return apiService.delete(`/meetings/calendar/${integrationId}`);
  },

  async syncCalendar(integrationId: string): Promise<any> {
    return apiService.post(`/meetings/calendar/${integrationId}/sync`);
  },

  async getCalendarEvents(params?: { startDate?: string; endDate?: string; integrationId?: string }): Promise<any> {
    return apiService.get('/meetings/calendar/events', { params });
  },

  async createCalendarEvent(data: {
    title: string;
    description?: string;
    start_time: string;
    end_time: string;
    location?: string;
    busy?: boolean;
    reminder_minutes?: number;
  }): Promise<any> {
    return apiService.post('/meetings/calendar/events', data);
  },

  // ==================== Availability ====================

  async getAvailability(userId: string, params?: { startDate?: string; endDate?: string }): Promise<any> {
    return apiService.get(`/meetings/availability/${userId}`, { params });
  },

  async getCommonAvailability(data: { userIds: string[]; startDate: string; endDate: string; duration: number }): Promise<any> {
    return apiService.post('/meetings/availability/common', data);
  },
};
